export const COLUMN_ORDER_MAIL_EXAMPLE_CONTENT_URL = 'https://proffit.jp/column/2/fRBsn9vj';
export const CONSULTANT_SEARCH_LINK = 'https://landing.proffit.jp/consulsearch-about';
/** ランディングページ: セミナー */
export const LANDING_SEMINAR_URL = 'https://landing.proffit.jp/seminar';
export default CONSULTANT_SEARCH_LINK;
